import script from "./SettingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingPage.vue?vue&type=script&setup=true&lang=ts"

import "./SettingPage.vue?vue&type=style&index=0&id=46cc9be2&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46cc9be2"]])

export default __exports__